const variants = {
    ADMIN: 'outline-danger',
    TEAM_LEADER: 'outline-warning',
    USER: 'outline-primary'
};

export default role => !!variants[role] ? variants[role] : undefined;